module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-primary box-solid"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.newRole.name))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.name),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Name:',
      "name": 'name',
      "messages": {
        required: 'This field is required'
      }
    },
    model: {
      value: (_vm.newRole.name),
      callback: function($$v) {
        _vm.$set(_vm.newRole, "name", $$v)
      },
      expression: "newRole.name"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.description),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-form-input', {
    attrs: {
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'Description:',
      "name": 'desription'
    },
    model: {
      value: (_vm.newRole.description),
      callback: function($$v) {
        _vm.$set(_vm.newRole, "description", $$v)
      },
      expression: "newRole.description"
    }
  })], 1)], 1), _vm._v(" "), _c('validate', {
    staticClass: "hide"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.roleUpdated),
      expression: "roleUpdated"
    }],
    attrs: {
      "type": "text",
      "name": "roleUpdated"
    },
    domProps: {
      "value": (_vm.roleUpdated)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.roleUpdated = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.enable",
      value: (['role', 'updateRole']),
      expression: "['role', 'updateRole']",
      modifiers: {
        "enable": true
      }
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.formstate.$pristine || _vm.formstate.$invalid
    },
    on: {
      "click": _vm.updateRole
    }
  }, [_vm._v("Update Role")])]), _vm._v(" "), _c('div', {
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.enable",
      value: (['role', 'deleteRole']),
      expression: "['role', 'deleteRole']",
      modifiers: {
        "enable": true
      }
    }],
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.deleteRoleModal
    }
  }, [_vm._v("Delete Role")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.formstate.$pristine
    },
    on: {
      "click": _vm.clearChanges
    }
  }, [_vm._v("Clear Changes")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "permissions"
    }
  }, [(!_vm.loading) ? _c('role-permissions', {
    attrs: {
      "role": _vm.newRole
    }
  }) : _vm._e()], 1)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#permissions"
    }
  }, [_vm._v("Permissions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18d589aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/roles/RoleDetails.vue
// module id = 2279
// module chunks = 1